import { api } from "@/lib/api"
import { AnalyticsChart } from "./analytics-chart"

export function SlackChart() {
	const slackChartQuery = api.analytics.slackChart.useQuery({})

	return (
		<AnalyticsChart
			title="Slack"
			data={slackChartQuery.data}
			isLoading={slackChartQuery.isLoading}
		/>
	)
}
